import { Injectable } from "@angular/core";
import { HttpErrorResponse, HttpParams } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { WebService } from "../../services/web/web.service";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class BaseService {
  public HOST: string = environment.backendUrl;
  public HOST_BATCH: string = `${environment.backendUrl}/api/v2`;
  public HOST_UPLOADER: string = environment.backendUrl;

  constructor(private web: WebService) {}

  get(url: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.web.get(url, params);
  }

  post(body: any, url: string): Observable<any> {
    return this.web.post(body, url);
  }

  put(body: any, url: string): Observable<any> {
    return this.web.put(body, url);
  }

  delete(body: any, url: string): Observable<any> {
    return this.web.delete(body, url);
  }

  public handleError(error: HttpErrorResponse | any) {
    const message =
      error?.error?.message ??
      error?.message ??
      (typeof error === "string" ? error : "Error inesperado");
    return throwError(() => message);
  }

  public buildRequestParams(
    sort?: string,
    collection?: string,
    pager?: { pageIndex: number; pageSize: number },
  ): HttpParams {
    let params = new HttpParams();
    if (sort !== undefined) params = params.set("sort", sort);
    if (collection !== undefined) params = params.set("collection", collection);
    if (pager !== undefined) {
      params = params.set("index", pager.pageIndex.toString());
      params = params.set("size", pager.pageSize.toString());
    }
    return params;
  }
}
